import React, { useEffect, useRef, useState } from "react";
import { Button, Container, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "./Cart.css";
import { SendCartAction } from "../Redux/CartRedux";
import ProductDetaile from "./ProductDetaile";
import CustomerAddress from "./CustomerAddress";
import { AddressResetAction } from "../Redux/AddressDetailsRedux";
import {fetchUIDGallery} from "../Redux/GalleryUIDRedux";
import { Toast } from "primereact/toast";
import PurchaseConfirmation from "./PurchaseConfirmation";
import { ResetConfirmOrderAction } from "../Redux/ConfirmOrderRedux";

function Cart() {
  const dispatch = useDispatch();
  const posts = useSelector((state) => state.Cart);
  const [viewBox, setViewBox] = useState({ Hide: false });
  const posts2 = useSelector((state) => state.AddressDetails);
  const posts3 = useSelector((state) => state.ConfirmOrder);
  const [viewBox2, setViewBox2] = useState({ Hide: false });
  const [viewBox3, setViewBox3] = useState({ Hide: false });
  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const toast = useRef(null);
  const QtyAction = (Action, UID) => {
    dispatch(SendCartAction([Action, UID]));
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  const showPurchasedSuccess = (Message, Alert) => {
    toast.current.show({
      severity: Alert,
      summary: "Added to Order",
      detail: Message,
      life: 1000,
    });
  };

  const showSuccess = (Message) => {
    toast.current.show({
      severity: "warning",
      summary: "Check Order Qty",
      detail: Message,
      life: 2000,
    });
  };

  useEffect(() => {
    if (posts2.isSuccessFull) {
      setViewBox2({ Hide: false });
      dispatch(AddressResetAction());
    }
  }, [dispatch, posts2.isSuccessFull]);

  useEffect(() => {
    setViewBox3({ Hide: false });
    if (posts3.data ? true : false) {
      if (posts3.data["Responce"] === "SuccessFull") {
        showPurchasedSuccess(posts3.data["Responce"], "success");
      } else {
        showPurchasedSuccess(posts3.data["Responce"], "warning");
      }
      dispatch(SendCartAction(["None", ""]));
      dispatch(ResetConfirmOrderAction());
    }
  }, [dispatch, posts3]);

  useEffect(() => {
    dispatch(SendCartAction(["None", ""]));
    setWindowDimensions({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }, [dispatch]);

  const HandelCheckValidQty = async () => {
    await dispatch(SendCartAction(["None", ""]));

    let Trigger1 = true;

    for (const [, value] of Object.entries(posts.data2)) {
      if (value === "") {
        Trigger1 = false;
        showSuccess("Fill all Address details Button in at Bottom Left");
        break;
      }
    }

    posts.data?.map((post) =>
      parseInt(post.Qty) < parseInt(post.CQty)
        ? (showSuccess(
            "Check QTY of " + post.Name + " is Greater than in Stock"
          ),
          (Trigger1 = false))
        : null
    );

    if (Trigger1) {
      setViewBox3({ Hide: true });
    }
  };

  let totalAmount = 0;
  posts.data?.map(
    (post) =>
      (totalAmount = totalAmount + parseInt(post.Price) * parseInt(post.CQty))
  );

  const openDetailedDilogBox = async (UID) => {
    await dispatch(fetchUIDGallery(UID));
    setViewBox({ Hide: true});
  };

  //   const OpenPayment = () =>{
  // if(posts)

  //   }
  return (
    <Container fluid="xl" className="Cointainer02">
      <Toast ref={toast} position="center" />
      <div className={posts.isFilled + " Div01"}>
        <Table hover>
          {windowDimensions["width"] > 800 ? (
            <>
              <thead>
                <tr className="Header">
                  <td>Product</td>
                  <td></td>
                  <td>Stock Qty</td>
                  <td>Price Per Product</td>
                  <td>Qty</td>
                  <td>Total Price</td>
                </tr>
              </thead>

              <tbody>
                {posts.data?.map((post) => (
                  <tr key={"a" + post.UID}>
                    <td>
                      <div className="PhotosFrame03">
                        <img
                          className="Photos03"
                          src={
                            // process.env.REACT_APP_BackEndIP +"/Static/Art/" +post.UID +"/1.png"
                            
                    `${process.env.REACT_APP_BackEndIP}/Static/Art/${post.UID}/1.png?${new Date().getTime()}`
                          }
                          onClick={() => openDetailedDilogBox(post.UID)}
                          alt="Not Available"
                        />
                      </div>
                    </td>
                    <td className="TextFrame03 MO01">
                      <strong>{post.Name}</strong>
                    </td>

                    <td className="TextFrame02">{post.Qty}</td>

                    <td className="TextFrame02">{"Rs: " + post.Price}</td>
                    <td className="FilterBar06">
                      <div className="FilterBar05">
                        {posts.isLoading === "hide" ? (
                          <>
                            <Button
                              className="pi pi-minus Button08"
                              onClick={() => QtyAction("DEC", post.UID)}
                            ></Button>
                          </>
                        ) : (
                          <Button className="pi pi-minus Button10"></Button>
                        )}
                        <input
                          className="PageIP02"
                          value={post.CQty}
                          disabled
                        />

                        {posts.isLoading === "hide" ? (
                          <>
                            {parseInt(post.CQty) < parseInt(post.Qty) ? (
                              <Button
                                className="pi pi-plus Button08"
                                onClick={() => QtyAction("INC", post.UID)}
                              ></Button>
                            ) : (
                              <Button className="pi pi-plus Button08"></Button>
                            )}
                          </>
                        ) : (
                          <Button className="pi pi-plus Button10"></Button>
                        )}
                      </div>

                      {posts.isLoading === "hide" ? (
                        <>
                          <p
                            className="TextStyle01"
                            onClick={() => QtyAction("RMV", post.UID)}
                          >
                            Remove
                          </p>
                        </>
                      ) : (
                        <p className="TextStyle01">Remove</p>
                      )}
                    </td>

                    <td className="TextFrame02">
                      {"Rs: " + parseInt(post.Price) * parseInt(post.CQty)}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="TextFrame04">Total Price:</td>
                  <td className="TextFrame02">{"Rs: " + totalAmount}</td>
                </tr>
                {/* <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="TextFrame02">{"Rs: " + totalAmount}</td>
                </tr> */}
                <tr>
                  <td>
                    <Button
                      className="Button12"
                      onClick={() => setViewBox2({ Hide: true })}
                    >
                      Address Details
                    </Button>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td className="TextFrame02">
                    <Button className="Button09" onClick={HandelCheckValidQty}>
                      Purchase
                    </Button>
                  </td>
                </tr>
              </tbody>
            </>
          ) : (
            <>
              <thead>
                <tr className="Header">
                  <td>Product</td>
                  <td>Qty/Price</td>
                  <td>Purchase Qty/Price</td>
                </tr>
              </thead>

              <tbody>
                {posts.data?.map((post) => (
                  <tr key={"a" + post.UID}>
                    <td>
                      <div className="PhotosFrame03">
                        <img
                          className="Photos03"
                          src={
                            // process.env.REACT_APP_BackEndIP +"/Static/Art/" +post.UID +"/1.png"
                            
                    `${process.env.REACT_APP_BackEndIP}/Static/Art/${post.UID}/1.png?${new Date().getTime()}`
                          }
                          onClick={() => openDetailedDilogBox(post.UID)}
                          alt="Not Available"
                        />
                      </div>
                      <div className="FilterBar06">
                        <strong>{post.Name}</strong>
                      </div>
                    </td>
                    <td className="TextFrame02">
                      <div>{"Qty:" + post.Qty}</div>
                      <div>{"Rs:" + post.Price}</div>
                    </td>

                    <td className="FilterBar06">
                      <div className="FilterBar05">
                        {posts.isLoading === "hide" ? (
                          <>
                            <Button
                              className="pi pi-minus Button08"
                              onClick={() => QtyAction("DEC", post.UID)}
                            ></Button>
                          </>
                        ) : (
                          <Button className="pi pi-minus Button10"></Button>
                        )}
                        <input
                          className="PageIP02"
                          value={post.CQty}
                          disabled
                        />
                        {posts.isLoading === "hide" ? (
                          <>
                            {parseInt(post.CQty) < parseInt(post.Qty) ? (
                              <Button
                                className="pi pi-plus Button08"
                                onClick={() => QtyAction("INC", post.UID)}
                              ></Button>
                            ) : (
                              <Button className="pi pi-plus Button08"></Button>
                            )}
                          </>
                        ) : (
                          <Button className="pi pi-plus Button10"></Button>
                        )}
                      </div>
                      {posts.isLoading === "hide" ? (
                        <>
                          <p
                            className="TextStyle01"
                            onClick={() => QtyAction("RMV", post.UID)}
                          >
                            Remove
                          </p>
                        </>
                      ) : (
                        <p className="TextStyle01">Remove</p>
                      )}
                      <div>
                        {"Total Rs:" +
                          parseInt(post.Price) * parseInt(post.CQty)}
                      </div>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td></td>
                  <td className="TextFrame04">Total Price:</td>
                  <td className="TextFrame02">{"Rs:" + totalAmount}</td>
                </tr>
                {/* <tr>
                  <td></td>
                  <td></td>
                  <td className="TextFrame02">{"Rs:" + totalAmount}</td>
                </tr> */}
                <tr>
                  <td>
                    <Button
                      className="Button12"
                      onClick={() => setViewBox2({ Hide: true })}
                    >
                      Address Details
                    </Button>
                  </td>
                  <td></td>
                  <td className="TextFrame02">
                    <Button className="Button09" onClick={HandelCheckValidQty}>
                      Purchase
                    </Button>
                  </td>
                </tr>
              </tbody>
            </>
          )}
        </Table>
      </div>

      {/* {posts.isLoading && (
        <div className="Loading04 d-flex justify-content-center ">
          <Spinner animation="border" variant="secondary" />
        </div>
      )} */}

      <div className={posts.isEmpty + " d-flex justify-content-center"}>
        <h1>Your Cart Is Empty</h1>
      </div>

      <ProductDetaile
        show={viewBox.Hide}
        onHide={() => setViewBox({  Hide: false })}
      />
      <CustomerAddress
        show={viewBox2.Hide}
        onHide={() => setViewBox2({ Hide: false })}
      />
      <PurchaseConfirmation
        show={viewBox3.Hide}
        onHide={() => setViewBox3({ Hide: false })}
      />
    </Container>
  );
}

export default Cart;
